export default __webpack_public_path__ + "static/media/SFProTextSB.9a80c318.woff";